import ContentLoader from 'react-content-loader';
import { useTranslation } from 'react-i18next';

const RTL = 'rtl';

function AlternativeDealLoader() {
    const { i18n } = useTranslation();
    const isRtl = i18n.dir() === RTL;

    return (
        <div className="alternative-deal">
            <ContentLoader
                width="100%"
                height={32}
                viewBox="0 0 500 32"
                style={{
                    transform: isRtl ? 'scaleX(-1)' : undefined,
                    transformOrigin: 'center',
                }}
            >
                {/* label */}
                <rect x="0" y="6" rx="3" ry="3" width="140" height="14" />
                {/* divider */}
                <rect x="152" y="2" rx="1" ry="1" width="2" height="28" />
                {/* price text */}
                <rect x="166" y="2" rx="3" ry="3" width="160" height="14" />
                {/* tax row */}
                <rect x="166" y="20" rx="3" ry="3" width="120" height="12" />
                {/* arrow button */}
                <rect x="476" y="4" rx="4" ry="4" width="24" height="24" />
            </ContentLoader>
        </div>
    );
}

export default AlternativeDealLoader;
